import React, { useState, useEffect } from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-scroll';

function Navbar(props) {
  const [width, setWidth] = useState(window.innerWidth);

  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, [])

  return (
    <div>
      {width > 650 ? (
        <nav className="navbar-horizontal">
          <div className="hor-nav-content">
            <Link to="aboutSection" spy={true} smooth={true} duration={700}>
              <Fade duration={750}><div className="hor-nav-item">About</div></Fade>
            </Link>
            <Link to="skillsSection" spy={true} smooth={true} duration={850}>
              <Fade duration={1500}><div className="hor-nav-item">Skills</div></Fade>
            </Link>
            <Link to="projectsSection" spy={true} smooth={true} duration={1000}>
              <Fade duration={2250}><div className="hor-nav-item">Projects</div></Fade>
            </Link>
            <Link to="hobbiesSection" spy={true} smooth={true} duration={1150}>
              <Fade duration={3000}><div className="hor-nav-item">Hobbies</div></Fade>
            </Link>
            <Link to="contactSection" spy={true} smooth={true} duration={1150}>
              <Fade duration={3750}><div className="hor-nav-item">Contact</div></Fade>
            </Link>
          </div>
        </nav>
      ) : (
        <nav className="navbar">
          <ul className="navbar-nav">{ props.children }</ul>
        </nav>
      )}
    </div>
  )
}

export default Navbar;
